"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STANDARD_PROPS = void 0;
exports.STANDARD_PROPS = [
    'shimBackgroundType',
    'userClosable',
    'disableReturnFocus',
    'size',
    'fa',
    'layer',
];
//# sourceMappingURL=FeatureAppInLayerParams.js.map